import { useQuery } from "react-query"
import { DataBaseService } from "../services/DatabaseService"

export function useGetReferrals({
  page,
  sort,
  filter,
}: {
  page?: number
  sort?: string
  filter?: { key: string; value: string }
} = {}) {
  const { data, isLoading, error } = useQuery(
    ["referrals", page, sort, filter],
    () => DataBaseService.getReferrals({ page, sort, filter }),
    { useErrorBoundary: true },
  )
  return { data, isLoading, error }
}
